<template>
	<div>
		<navigationbar :parentToChild="name" v-if="show"></navigationbar>
		<div class="collect-box" v-if="uid !== ''">
		  <img v-if="collection === 1" src="../assets/images/icon/collect.png" alt="" @click="cancelCollectionEvent" />
		  <img v-else src="../assets/images/icon/no-collect.png" alt="" @click="collectionEvent" />
		</div>
		<div class="fadeInRight">
			<div :class="{'content11':show}">
				<div>
					<div class="product">
					  <div v-show="bannerList.length > 0" class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                  <div v-if="item.typeId === 1">
                    <a :href="item.picturesLink"><img class="imageUrl" :src="item.imageUrl"></a>
                  </div>
                  <div v-else class="videoComponent">
                    <video v-if="isDisplay || item.imageUrl === ''" class="video" controls autoplay :src="item.videoUrl"></video>
                    <div v-else class="videoCover">
                      <div class="playButton" @click="isDisplayEvent"></div>
                      <img class="imageUrl" :src="item.imageUrl" @click="previewImg(item.imageUrl)">
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div v-if="bannerList.length === 0" class="mainImageBox">
              <img class="mainImageUrl" :src="mainImageUrl" @click="previewImg(mainImageUrl)">
            </div>
					</div>
					<div class="listhr"></div>
					<div class="list" v-for="(goods,index) in instructionList" :key="goods.id" @click="sendInstruction(goods.id,index)">
						<div class="quick">
						  <div v-if="goods.bgImage !== ''" :class="itembackground[5]" :style="{backgroundImage:'url('+goods.bgImage+')'}">
                <p class="item-title">{{ goods.catalogContentName }}</p>
                <p class="item-subtitle">{{ goods.subtitle }}</p>
              </div>
						  <div v-else-if="goods.recipeFlag === 0" :class="itembackground[index%4]">
                <p class="item-title">{{ goods.catalogContentName }}</p>
                <p class="item-subtitle">{{ goods.subtitle }}</p>
              </div>
						  <div v-else :class="itembackground[4]">
                <p class="item-title">{{ goods.catalogContentName }}</p>
                <p class="item-subtitle">{{ goods.subtitle }}</p>
              </div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<van-image-preview v-model="preViewShow" :images="previewImages"></van-image-preview>
	</div>
</template>

<script>
import getGoodsId from "@/components/common/getGoodsId";
//  import  '@/components/common/webVIew'
import navigationbar from "@/components/navigationbar";
import axios from "axios";
import apiConfig from "../api";
import Swiper from "@/../static/swiper.min.js";
import "@/../static/swiper.min.css";
export default {
	name: "goodsdetail",
	data() {
		return {
		  name: '美书',
		  isDisplay: false,
		  itembackground:['item item-wathetblue', 'item item-blue', 'item item-grey', 'item item-grey', 'item item-orange', 'item'],
		  bannerList: [],
			instructionList: [],
			mainImageUrl: '',
			from: "",
			show: false,
			swiper: null,
			duringtimer:'',
			productId: '',
			collection: 0,
			id: '',
			uid: '',
			preViewShow: false,
			previewImages: [],
		};
	},
  created() {
    this.uid = localStorage.getItem('uid') ? localStorage.getItem('uid') : '';
    this.productId = this.$route.query.id;
    const parmars = getGoodsId("model");
    if (parmars === null) {
      const url = apiConfig.serverAddress + apiConfig.product;
      const restParams = {
        productId: this.productId,
        openId: this.uid,
        needImgHttps: 1,
      }
      const headers = {
        'Content-Type': "application/json",
      }
      axios
      .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
      .then(response => {
        this.fillInfo(response);
      });
    } else {
      this.from = getGoodsId("from");
      const url = apiConfig.serverAddress + apiConfig.customerType;
      
      const restParams = {
        model: parmars
      }
      const headers = {
        'Content-Type': "application/json",
      }
      axios  //axios请求体BODY上为model
        .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
        .then(response => {
          this.fillInfo(response);
        })
        .catch(error => {
          console.log("网络错误，不能访问", error);
        });
    }		
	},
	components: {
		navigationbar,
		Swiper
	},
	methods: {
	  previewImg(imgUrl) {
	    this.preViewShow = true;
	    this.previewImages = [];
	    this.previewImages.push(imgUrl);
	  },
	  cancelCollectionEvent() {
	    const url = apiConfig.serverAddress + apiConfig.cancelCollection;
      const restParams = {
        productId: this.id,
        openId: this.uid,
      }
      const headers = {
        'Content-Type': "application/json",
      }
      axios  //axios请求体BODY上为model
      .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
      .then(() => {
        this.collection = 0;
      });
	  },
	  collectionEvent() {
      const url = apiConfig.serverAddress + apiConfig.collection;
      const restParams = {
        productId: this.id,
        openId: this.uid,
      }
      const headers = {
        'Content-Type': "application/json",
      }
      axios  //axios请求体BODY上为model
      .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
      .then(() => {
        this.collection = 1;
      });
    },
	  fillInfo(response) {
	    if(response.data.code === '000000'){
	      this.collection = response.data.data.collection ? 1 : 0;
        this.instructionList = response.data.data.instructionList;
        this.bannerList = response.data.data.bannerList ? response.data.data.bannerList : [];
        this.mainImageUrl = response.data.data.imageUrl
        this.id = response.data.data.id;
        this.name = response.data.data.categoryName + ' ' + response.data.data.productModel;
        // document.title = this.name;
        if (!(/meiju|msmart/.test(navigator.userAgent.toLowerCase()))) {
          document.title = this.name;
        }
        window.collectEvent('config', {
          id: response.data.data.id,
          productCodes:response.data.data.productCodes,
          productModel:response.data.data.productModel,
          brandName:response.data.data.brandName,
          categoryId:response.data.data.categoryId,
          categoryName:response.data.data.categoryName,
          mainCategoryId:response.data.data.mainCategoryId,
          mainCategoryName:response.data.data.mainCategoryName
        
        });
        window.collectEvent('send')
        //说明书点击量
        window.collectEvent('ic_h5_instructionPV'); 
      }else{
        console.log("当前型号没有相应数据返回!");
      }
      this.duringtimer=new Date();
	  },
	  isDisplayEvent() {
	    if(!this.isDisplay) {
        this.swiper.autoplay.stop();
      }
	    this.isDisplay = !this.isDisplay;
	    
	  },
	  autoplayStart() {
	    this.isDisplay = !this.isDisplay;
	    this.swiper.autoplay.start();
	  },
		sendInstruction(id,index) {
			window.collectEvent('beconEvent','ic_h5_directoryClick',{catalogContentid:id,catalogContentName:this.instructionList[index].catalogContentName});
		
			const t = id;
			this.$router.push(`/detaillist/detail/goodsdetail/instruction/${t}`);
      this.$route.params.id = t;
      this.$route.params.name = this.name;
		}
	},
	mounted() {
		//判断访问终端
		// eslint-disable-next-line eqeqeq
		const browser = {
			versions: (function() {
				const u = navigator.userAgent;
				return {
					trident: u.indexOf("Trident") > -1, //IE内核
					presto: u.indexOf("Presto") > -1, //opera内核
					webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
					gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, //火狐内核
					mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
					ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
					android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
					iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
					iPad: u.indexOf("iPad") > -1, //是否iPad
					webApp: u.indexOf("Safari") === -1, //是否web应该程序，没有头部与底部
					weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
					hongmeng: u.indexOf("MideaOpenHormanyNext") > -1,
					qq: u.match(/\sQQ/i) === " qq" //是否QQ
				};
			})(),
			language: (navigator.browserLanguage || navigator.language).toLowerCase()
		};
		
		if (browser.versions.hongmeng) {
      this.show = true;
    }
		if (browser.versions.android) {
			this.show = true;
		}
		if (browser.versions.ios && this.from !== "control") {
			this.show = true;
		}
		if (browser.versions.iPad && this.from !== "control") {
			this.show = true;
		}
		if (browser.versions.iPhone && this.from !== "control") {
			this.show = true;
		}
		const program = getGoodsId("program");
		if (this.from === "weex" || program === 'miniColmo') {
			this.show = false;
		}
		// 是否是美居app
		if (/meiju|msmart/.test(navigator.userAgent.toLowerCase())) {
			this.show = false;
		}
		const _this = this;
		this.swiper = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination"
      },
      loop : true,
      speed:2000,
      autoplay:true,
      observer: true,
      observeParents: true,
      on: {
        slideChangeTransitionEnd: function(){
          if(_this.isDisplay){
            _this.autoplayStart()
          }
        },
      },
    });
	},
	beforeDestroy(){
		const now=new Date();
    window.collectEvent('beconEvent','ic_h5_instructionDuration',{'instructionDuration':now-this.duringtimer});
		this.duringtimer='';
  },

};
</script>


<style scoped>
.content11 {
	margin-top: 100px;
}
.product {
	display: flex;
	align-items: center;
	border: 1px solid #e8e8e8;
	background: #ffffff;
	position: relative;
	height: 400px;
	overflow: hidden;
}

.listhr {
	height: 20px;
}

.list {
	padding: 1px 20px;
	margin-top: 10px;
}

.item {
	min-height: 140px;
	padding: 40px 62px 0;
	border-radius: 10px;
	background: #ffffff;
	margin-bottom: 8px;
	background-size:100% 100%;
}
.item-blue{
  background-image: url(../assets/img/blue.png);
}
.item-grey{
  background-image: url(../assets/img/grey.png);
}
.item-orange{
  background-image: url(../assets/img/orange.png);
}
.item-wathetblue{
  background-image: url(../assets/img/wathetblue.png);
}

.quick {
	margin-bottom: 6px;
	border: 1px solid #e0e0e0;
	border-radius: 10px;
	background: #ffffff;
}

.quick .item {
	border: none;
	margin: 0 auto;
}
.item-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 40px;
  color: #ffffff;
  margin-top: 25px;
  overflow: hidden;
}
.item-subtitle {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 30px;
  color: #ffffff;
  overflow: hidden;
}
.swiper-container {
  width: 100%;
  min-height: 400px;
  background: #ffffff;
}

.mainImageBox{
  width: 100%;
  height: 400px;
  text-align: center;
}
.mainImageUrl{
  width: auto;
  height: 100%;
}

.imageUrl{
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: contain;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #ffffff;
  min-height: 400px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
}
.videoComponent{
  width: 100%;
  min-height: 400px;
  position: relative;
  background: #ffffff;
}
.video{
  width: 100%;
  min-height: 400px;
  margin-top: 150px;
}
.videoCover{
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 10;
}
.playButton{
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%,-50%);
  width: 1.28rem;
  height: 1.28rem;
  z-index: 99;
  background: url(../assets/img/open.png) no-repeat;
  background-size: 100% 100%;
}
.collect-box {
  position: fixed;
  z-index: 2;
  right: 20px;
  top: 150px;
}
.collect-box img {
  width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/app.vue